// Shared Tailwind class strings for tables, info fields, and common layout patterns.
// Import and use these instead of redeclaring the same constants in every page file.

export const thClass =
  'bg-surface-alt px-4 py-3 text-left font-semibold text-text-2 text-[0.75rem] uppercase tracking-[0.05em] border-b border-border whitespace-nowrap'

export const tdClass =
  'px-4 py-[0.8rem] border-b border-border text-text align-middle transition-colors duration-150'

// Apply to <tbody> to get row hover without injecting a <style> tag.
export const tbodyHoverClass = '[&>tr:hover>td]:bg-surface-hover'

export const infoLabelClass =
  'text-xs font-semibold text-text-3 uppercase tracking-[0.04em] mb-[0.2rem]'

export const infoValueClass = 'text-[0.925rem] text-text'

export const infoEmptyClass = 'text-[0.925rem] text-text-4 italic'

export const crumbLinkClass = 'text-accent no-underline font-medium hover:underline'

export const skeletonClass =
  'rounded bg-[length:200%_100%] animate-[shimmer_1.4s_infinite]'
  + ' [background-image:linear-gradient(90deg,var(--skeleton-from)_25%,var(--skeleton-to)_50%,var(--skeleton-from)_75%)]'

export const pageHeaderClass =
  'flex items-start justify-between mb-6 gap-3 flex-wrap'

export const pageTitleClass = 'text-[1.4rem] font-bold text-text-heading tracking-[-0.01em] m-0'

export const sectionHeadingClass =
  'text-[0.95rem] font-semibold text-text-heading m-0'

export const badgeBaseClass =
  'inline-flex items-center px-[0.6rem] py-[0.2rem] rounded-full text-xs font-medium'

export const emptyStateClass =
  'text-center py-12 px-4 text-text-3'

export const filterBarClass =
  'flex flex-wrap items-center gap-3 mb-4'

// Common input style used in filter bars / standalone inputs (not FormField-wrapped)
export const filterInputClass =
  'py-[0.55rem] px-3 border border-border-input rounded-md text-sm outline-none bg-surface text-text transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-accent focus-visible:border-accent'
